<h-dynamic-box
    [boxType]="boxType"
    [imageSrc]="imageSrc"
    [imageConfig]="imageAspectRatio"
    [labelValue]="labelValue"
    [variant]="variant"
    [checkedImageVariant]="currentProduct?.sku === variant.sku"
    [unavailable]="isOutOfStock"
    [formGroup]="formGroup"
    [formName]="formName"
    [value]="boxValue"
    [hasFixedWidth]="hasFixedWidth"
    [inputId]="inputId"
    [required]="true"
    [checked]="checked"
    [titleValue]="titleValue"
    [inputAriaInvalid]="!checked"
    [inputAriaDescribedby]="isSizeMessageAlertDisplay() ? 'size-alert-message' : undefined"
    (handleChange)="handleChange()"
    (handleClick)="handleSelectVariant()"
    (handleFocus)="handleFocus()"
    (handleBlur)="handleBlur()">
    <ng-container content-hidden>
        <label [attr.for]="inputId">
            <span [attr.role]="'text'" hSrOnlyNoSnippet>
                {{ labelValue }}
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <!-- availability -->
                {{ productAvailabilityStatus }}
            </span>
        </label>
    </ng-container>
</h-dynamic-box>
